<template>
  <div
    v-if="isVisible"
    class="p-config-candidates-list__row"
    :class="{ 'is-checked': isChecked }"
    @click.prevent="click"
  >
    <div
      class="p-config-candidates-list__col p-config-candidates-list__col--check"
    >
      <Checkbox
        v-if="input === 'checkbox'"
        :id="'user-candidate_' + type + '_' + item.userId"
        name="candidate[]"
        :value="item"
        :checked="checked"
        ref="input"
        @change="change"
      />
      <Radio
        v-else
        :id="'user-candidate_' + type + '_' + item.userId"
        name="candidate"
        :value="item"
        :checked="checked"
        ref="input"
        @change="change"
      />
    </div>
    <div class="p-config-candidates-list__col">
      {{ item.name }}
    </div>
    <div class="p-config-candidates-list__col">
      {{ item.mailAddress }}
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox';
import Radio from '@/components/Radio';

export default {
  props: {
    checked: {
      type: [Array, Object],
      required: false
    },
    input: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: false
    }
  },
  components: {
    Checkbox,
    Radio
  },
  computed: {
    isChecked() {
      if (this.input === 'checkbox') {
        return this.checked.some(
          checked => checked.userId === this.item.userId
        );
      } else {
        return this.checked.userId === this.item.userId;
      }
    },
    isVisible() {
      // 選択済みリストには未選択アイテムを表示しない
      if (this.type === 'selected' && !this.isChecked) {
        return false;
      }
      return true;
    }
  },
  methods: {
    change(checked) {
      this.$emit('change', checked);
    },
    click() {
      this.$refs.input.change();
    }
  }
};
</script>
